module.exports = [{"id":1,"size":500,"name":500,"colors":[{"id":1,"name":"white","prices":[{"id":1,"price":160},{"id":3,"price":185}]},{"id":2,"name":"cmyk","prices":[{"id":1,"price":169},{"id":3,"price":196}]}]},{"id":2,"size":700,"name":700,"colors":[{"id":1,"name":"white","prices":[{"id":1,"price":175},{"id":3,"price":215.25}]},{"id":2,"name":"cmyk","prices":[{"id":1,"price":199},{"id":3,"price":244.8}]}]}]


//////////////////
// WEBPACK FOOTER
// ./src/data/ink.json
// module id = 176
// module chunks = 0